import { Box, Typography, styled } from "@mui/material";
import { CustomDisplayItem } from "@/components/custom/custom-display-item";

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.up("lg")]: { flexDirection: "row" },
}));

const Grid = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(2),
  [theme.breakpoints.up("md")]: { gridTemplateColumns: "1fr 1fr" },
}));

const Side = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  [theme.breakpoints.up("lg")]: { width: 256 },
}));

const SectionTitle = ({ title, description }) => (
  <Side>
    <Typography fontWeight={500} fontSize={18}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    )}
  </Side>
);

const KycBusinessAccount = ({ d }) => {
  return (
    <Row>
      <SectionTitle
        title="Business Account"
        description="Linked bank account details."
      />
      <Grid>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Account Provider"
            value={d?.businessAccountProvider || "-"}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Account Number"
            value={d?.businessAccountNumber || "-"}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Account Name"
            value={d?.businessAccountName || "-"}
          />
        </Box>
      </Grid>
    </Row>
  );
};

export default KycBusinessAccount;
